module.exports = __webpack_public_path__ + "img/川木香.1c90009d.jpg";